// Configuration constants - adjust these values as needed
const SHIPPING_CONFIG = {
  FREE_SHIPPING_THRESHOLD: 5000, // $100.00 in cents
  FREE_SHIPPING_MESSAGE: "<b>You've unlocked FREE SHIPPING!</b>",
  SHIPPING_MESSAGE_TEMPLATE: "You're <b>[price] away</b> from FREE SHIPPING",
};

const ShippingProgress = {
  init: function () {
    this.updateShippingProgress();
    this.bindEvents();
  },

  bindEvents: function () {
    // Subscribe to Dawn's pub/sub cart updates — these include cartData
    // so we can update the progress bar without any extra /cart.js fetch.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event && event.cartData) {
          this.renderProgress(event.cartData.total_price);
        } else {
          this.updateShippingProgress();
        }
      });
    }
  },

  // Fetch /cart.js only when we don't already have cart data (e.g. initial load)
  updateShippingProgress: function () {
    var self = this;
    var progressBar = document.querySelector('.cart__progress_bar');
    if (!progressBar) return;

    fetch('/cart.js')
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.json();
      })
      .then(function (cart) {
        self.renderProgress(cart.total_price);
      })
      .catch(function (error) {
        console.error('Error fetching cart:', error);
        progressBar.classList.remove('updating');
      });
  },

  renderProgress: function (cartTotal) {
    var progressBar = document.querySelector('.cart__progress_bar');
    if (!progressBar) return;

    var progressBarElement = progressBar.querySelector('.progress-bar');
    var messageElement = progressBar.querySelector('.progress_bar_shipping_message');
    if (!progressBarElement || !messageElement) return;

    var remainingAmount = SHIPPING_CONFIG.FREE_SHIPPING_THRESHOLD - cartTotal;
    var percent = Math.floor((cartTotal * 100) / SHIPPING_CONFIG.FREE_SHIPPING_THRESHOLD);
    var cappedPercent = percent > 100 ? 100 : percent;

    progressBar.classList.add('updating');

    setTimeout(() => {
      progressBarElement.style.width = cappedPercent + '%';
      progressBarElement.setAttribute('aria-valuenow', cappedPercent);
      progressBarElement.textContent = cappedPercent + '%';

      if (cappedPercent >= 100) {
        progressBar.querySelector('.progress_bar_shipping').classList.add('success');
        messageElement.innerHTML = SHIPPING_CONFIG.FREE_SHIPPING_MESSAGE;
      } else {
        progressBar.querySelector('.progress_bar_shipping').classList.remove('success');
        var formattedPrice = this.formatMoney(remainingAmount);
        messageElement.innerHTML = SHIPPING_CONFIG.SHIPPING_MESSAGE_TEMPLATE.replace('[price]', formattedPrice);
      }

      setTimeout(() => {
        progressBar.classList.remove('updating');
      }, 50);
    }, 300);
  },

  formatMoney: function (cents) {
    return '$' + (cents / 100).toFixed(2);
  },
};

// Initialize once the DOM is fully loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    ShippingProgress.init();
  });
} else {
  ShippingProgress.init();
}
